import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import AOT from "./Containers/AOT/Home";
import AOT_Projects from "./Containers/AOT/Projects";
import AOT_Media from "./Containers/AOT/Media";
import AOT_Exchange from "./Containers/AOT/Exchange";

const App = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={AOT} />
        <Route exact path="/projects" component={AOT_Projects} />
        <Route exact path="/learning" component={AOT_Media} />
        <Route exact path="/exchange/:id" component={AOT_Exchange} />
      </Switch>
    </Router>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js